import Dropdown from '../lib/dropdown';

export default class BlockPartsSearch {

  init() {
    if (this.outlets.dropdown) {
      this.outlets.dropdown.forEach((dropdown) => {
        new Dropdown(dropdown);
      });
    }
  }

}
